import { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';
import { getSocialMedia } from '../lib/api';

const SocialIcon = ({ icon, className }) => {
  const icons = {
    facebook: (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
    instagram: (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
    tiktok: (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
      </svg>
    ),
    twitter: (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
    youtube: (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
    linkedin: (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
    whatsapp: (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
  };
  return icons[icon] || icons.facebook;
};

export const SocialSidebar = () => {
  const [socials, setSocials] = useState([]);
  const [hoveredId, setHoveredId] = useState(null);

  useEffect(() => {
    const fetchSocials = async () => {
      try {
        const res = await getSocialMedia();
        setSocials(res.data);
      } catch (err) {
        setSocials([
          { id: '1', name: 'Facebook', url: 'https://facebook.com', icon: 'facebook', color: '#1877F2' },
          { id: '2', name: 'Instagram', url: 'https://instagram.com', icon: 'instagram', color: '#E4405F' },
          { id: '3', name: 'TikTok', url: 'https://tiktok.com', icon: 'tiktok', color: '#000000' },
        ]);
      }
    };
    fetchSocials();
  }, []);

  if (socials.length === 0) return null;

  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-50" data-testid="social-sidebar">
      {socials.map((social, index) => {
        const isHovered = hoveredId === social.id;
        const topPosition = index * 50; // 48px height + 2px gap
        
        return (
          <a
            key={social.id}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            onMouseEnter={() => setHoveredId(social.id)}
            onMouseLeave={() => setHoveredId(null)}
            className="absolute right-0 flex items-center rounded-l-lg shadow-lg overflow-hidden"
            style={{ 
              backgroundColor: social.color,
              top: `${topPosition}px`,
              height: '48px',
              transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              width: isHovered ? '140px' : '48px',
            }}
            data-testid={`social-${social.icon}`}
          >
            {/* Text - positioned first, appears on left when expanded */}
            <div 
              className="flex items-center justify-end overflow-hidden"
              style={{
                width: isHovered ? '92px' : '0px',
                transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                paddingLeft: isHovered ? '12px' : '0px',
              }}
            >
              <span 
                className="text-white font-medium text-sm whitespace-nowrap"
                style={{
                  opacity: isHovered ? 1 : 0,
                  transition: 'opacity 0.3s ease',
                  transitionDelay: isHovered ? '0.15s' : '0s',
                }}
              >
                {social.name}
              </span>
            </div>
            
            {/* Icon - always on the right */}
            <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
              <SocialIcon icon={social.icon} className="w-5 h-5 text-white" />
            </div>
          </a>
        );
      })}
      
      {/* Container height placeholder */}
      <div style={{ height: `${socials.length * 50}px`, width: '48px' }} />
    </div>
  );
};

export const CallButton = ({ phone = '0176 34681594' }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href={`tel:${phone.replace(/\s/g, '')}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-6 right-6 z-50 flex items-center bg-[#D4B982] text-[#0A0A0A] rounded-full shadow-xl overflow-hidden"
      style={{
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        width: isHovered ? '170px' : '56px',
        height: '56px',
        transform: isHovered ? 'scale(1.05)' : 'scale(1)',
      }}
      data-testid="call-button"
    >
      {/* Text - on left */}
      <div 
        className="flex items-center justify-end overflow-hidden"
        style={{
          width: isHovered ? '114px' : '0px',
          transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          paddingLeft: isHovered ? '16px' : '0px',
        }}
      >
        <span 
          className="font-semibold text-sm whitespace-nowrap"
          style={{
            opacity: isHovered ? 1 : 0,
            transition: 'opacity 0.3s ease',
            transitionDelay: isHovered ? '0.15s' : '0s',
          }}
        >
          Jetzt anrufen
        </span>
      </div>
      
      {/* Icon - on right */}
      <div 
        className="w-14 h-14 flex items-center justify-center flex-shrink-0"
        style={{
          transition: 'transform 0.3s ease',
          transform: isHovered ? 'rotate(12deg)' : 'rotate(0)',
        }}
      >
        <Phone size={24} />
      </div>

      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#D4B982] animate-ping opacity-20 pointer-events-none" />
    </a>
  );
};
